export const HOMEWORK_STATUS = {
  NOT_DONE_HOMEWORK: 'NOT_DONE_HOMEWORK',
  DOING_HOMEWORK: 'DOING_HOMEWORK',
}

export const HONOR_SESSION_STATUS = {
  NONE: 'NONE',
  HONOR_CEREMONY: 'HONOR_CEREMONY',
}

export const PREV_REWARD_TYPE = {
  HOMEWORK_EXERCISE_TUTOR: 'HOMEWORK_EXERCISE_TUTOR',
  MONTHLY_CONTEST_TUTOR: 'MONTHLY_CONTEST_TUTOR',
  AI_SPEAK_TUTOR: 'AI_SPEAK_TUTOR',
  ATTENDANT_TUTOR: 'ATTENDANT_TUTOR',
  ABSENT_TUTOR: 'ABSENT_TUTOR',
  CUP_CLASSIN_TUTOR: 'CUP_CLASSIN_TUTOR',
}

export const SESSION_URL_API = {
  ASSIGN_COORDINATOR: 'api/calendar/class-regular/session/coordinator',
}

export const ABSENCE_RISK = {
  HIGH_RISK: 'HIGH_RISK',
  RISK: 'RISK',
  NONE: 'NONE',
}
